const UNITS = [
  [1e9, 'gigabyte'],
  [1e6, 'megabyte'],
] as const;

/** Decimal units, at least kB ("byte" has no short form in Intl). */
export function formatBytes(n: number, lng: string): string {
  const [div, unit] = UNITS.find(([d]) => n >= d) ?? [1e3, 'kilobyte'];
  return new Intl.NumberFormat(lng, { style: 'unit', unit, unitDisplay: 'short', maximumFractionDigits: 1 }).format(n / div);
}
